import React from "react";
import {
  Card,
  Typography,
  Box,
  IconButton,
  Button,
} from "@mui/material";

import FavoriteIcon from "@mui/icons-material/Favorite";
import CallIcon from "@mui/icons-material/Call";
import ChatIcon from "@mui/icons-material/Chat";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const BankAuctionReusableCard = ({ property }) => {
  if (!property) return null;

  return (
    <Card
      sx={{
        height: 130, // Keep height 130
        width: 300, // Keep width 290
        borderRadius: "14px",
        border: "2px solid #000",
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
        bgcolor: "#fff",
      }}
    >
      {/* IMAGE - Increased size */}
      <Box
        sx={{
          width: 70, // Increased from 120 to 140
          height: 120,
          ml: 1,
          borderRadius: "10px",
          overflow: "hidden",
          position: "relative",
          flexShrink: 0, // Prevent shrinking
        }}
      >
        <img
          src={
            property?.bank_pro_doc?.[0] ||
            "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2"
          }
          alt="Property"
          style={{ 
            width: "100%", 
            height: "100%", 
            objectFit: "cover",
            objectPosition: "center"
          }}
        />

        <IconButton
          sx={{
            position: "absolute",
            top: 4,
            right: 4,
            background: "#fff",
            width: 28,
            height: 28,
            '&:hover': {
              background: "#fff",
            }
          }}
        >
          <FavoriteIcon sx={{ color: "red", fontSize: 16 }} />
        </IconButton>
      </Box>

      {/* CONTENT - Adjusted for larger image */}
      <Box sx={{ flex: 1, px: 1.2, minWidth: 0 }}> {/* Added minWidth: 0 for text truncation */}
        <Typography fontSize="13px" fontWeight={600} align="right">
          ₹ {Number(property.price || 0).toLocaleString("en-IN")} Cr
        </Typography>

        <Typography fontSize="12px" noWrap>
          <b>Property ID:</b> {property.id}
        </Typography>

        <Typography fontSize="12px" noWrap>
          <b>Property:</b> Commercial Building
        </Typography>

        <Typography fontSize="12px" noWrap>
          <b>City/Town:</b> {property.location}
        </Typography>

        <Typography fontSize="11px" noWrap>
          <b>Bank:</b> {property.title}
        </Typography>

        {/* Buttons with fixed width */}
        <Box sx={{ display: "flex", gap: 0.5, mt: 0.5 }}>
          <Button 
            size="small" 
            variant="outlined" 
            startIcon={<CallIcon />}
            sx={{ 
              minWidth: '60px', // Slightly reduced
              fontSize: '11px', // Smaller font
              padding: '2px 4px'
            }}
          >
            Call
          </Button>
          <Button 
            size="small" 
            variant="outlined" 
            startIcon={<ChatIcon />}
            sx={{ 
              minWidth: '60px', // Slightly reduced
              fontSize: '11px', // Smaller font
              padding: '2px 4px'
            }}
          >
            Msg
          </Button>
          <Button 
            size="small" 
            variant="outlined" 
            startIcon={<LocationOnIcon />}
            sx={{ 
              minWidth: '60px', // Slightly reduced
              fontSize: '11px', // Smaller font
              padding: '2px 4px'
            }}
          >
            Map
          </Button>
        </Box>
      </Box>
    </Card>
  );
};

export default BankAuctionReusableCard;